import AppPage from "layouts/AppPage";
import { useParams } from "react-router";
import { useTaskTemplateDetailQuery } from "features/Resources/TaskTemplate/hooks";
import TaskTemplateForm from "features/Resources/TaskTemplate/Layout/TaskTemplateForm";
import { usePrebuiltTaskTemplateDetailQuery } from "features/Prebuilt/PrebuiltSharedTemplate/hooks";
import PrebuiltTaskTemplateDisplay from "features/Resources/TaskTemplate/Layout/PrebuiltTaskTemplateDisplay";
import CaminoBreadcrumbs from "components/Breadcrumbs";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { truncateEnd } from "helpers/string";

export default function TaskTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const { data = {}, isLoading } = useTaskTemplateDetailQuery(id, {
    enabled: !!id && id !== "new",
  });

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      <CaminoBreadcrumbs
        breadcrumbInfos={[
          { name: "Task Templates", toUrl: PEOPLE_TEAM_ROUTES.taskTemplates.index },
          { name: id === "new" ? "New" : `${truncateEnd(data?.name)}` },
        ]}
      />
      {(data || id === "new") && (
        <TaskTemplateForm id={id} data={data} />
      )}
    </AppPage>
  );
}

export function PrebuiltTaskTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const { data, isLoading } = usePrebuiltTaskTemplateDetailQuery(id!);

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      {data && (
        <PrebuiltTaskTemplateDisplay prebuiltTaskTemplate={data} />
      )}
    </AppPage>
  );
}
